import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  itemName?: string;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Slett',
  message = 'Er du sikker på at du vil slette',
  itemName,
  confirmText = 'Slett',
  cancelText = 'Avbryt',
  destructive = true,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className={cn('border-t-4 sm:max-w-xs', destructive ? 'border-t-destructive' : 'border-t-yellow-500')}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2.5">
            <TriangleAlert className={cn('h-5 w-5', destructive ? 'text-destructive' : 'text-yellow-500')} />
            {title}
          </DialogTitle>
        </DialogHeader>

        <div>
          <p className="text-sm text-foreground mb-2">{message}</p>
          {itemName && (
            <div className="bg-muted rounded-md p-3 mb-2">
              <p className="text-sm font-semibold">{itemName}</p>
            </div>
          )}
          {destructive && (
            <p className="text-xs text-destructive">Denne handlingen kan ikke angres.</p>
          )}
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant={destructive ? 'destructive' : 'default'} onClick={onConfirm}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
